module.exports = __webpack_public_path__ + "img/bg2.b5581802.jpg";